// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"94":"3cdb843e72ee6ea77e2f","830":"49d12318667ec5baa4bc"}[chunkId] + ".css";
};